import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
  isOpen: boolean;
};

const initialState: InitialState = {
  isOpen: false,
};

const sideBarSlice = createSlice({
  name: "sideBar",
  initialState,
  reducers: {
    openSideBar: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export default sideBarSlice.reducer;
export const { openSideBar } = sideBarSlice.actions;
